export default __webpack_public_path__ + "static/media/WhatsApLogo.1120e21c.png";